import HeaderContentsForBulkOrderSearch from '../../components/organism/headers/HeaderContentsForBulkOrderSearch.vue'
export default {
  components: { HeaderContentsForBulkOrderSearch }
}
